import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Input, Modal} from 'antd';
import {isModalOpened, modalData} from '../../redux/selectors/nav';
import {makeAction} from '../../redux/actions/makeAction';
import {CLOSE_MODAL, LOG_IN, OPEN_MODAL} from '../../redux/actions/actionTypes';
import _ from 'lodash';
import {push} from 'connected-react-router';
import {DASHBOARD_PAGE} from '../../configuration/paths';
import {store} from '../../index';
import FormError from '../FormError';
import {authErrors} from '../../redux/selectors/error';
import {FORGOT_PASSWORD_MODAL_ID, LoginModalId, SignUpModalId} from '../../services/constants';
import {ReactComponent as WarningTriangle} from '../../assets/img/warning-triangle.svg';
import {ReactComponent as SuccessCircle} from '../../assets/img/success-circle.svg';
import {withTranslation} from 'react-i18next';
import TranslatedText from '../TranslatedText';
import {ReactComponent as CloseIcon} from '../../assets/img/close.svg';
import {ReactComponent as ArrowLeft} from '../../assets/img/arrowLeft.svg';

const defaultState = {
  email: '',
  password: '',
  inProgress: false,
};
class LoginModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {...defaultState};
    this.submit = this.submit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (Object.keys(this.props.errors).length > Object.keys(prevProps.errors).length) {
      this.setState({inProgress: false});
    }
  }

  submit(event) {
    event.preventDefault();
    this.setState({inProgress: true});
    this.props.login({
      ...Object.fromEntries(new FormData(event.target)),
      callback: () => {
        _.get(this.props.data, 'fallbacks', [push(DASHBOARD_PAGE)]).map(store.dispatch);
        this.setState(defaultState);
      },
    });
  }

  onCancel() {
    this.props.closeModal();
    this.setState(defaultState);
  }

  render() {
    const message = _.get(this.props.data, 'message');
    return (
      <Modal
        title={<TranslatedText transKey="modals.login.title"/>}
        className="nav-modal login-modal"
        width={440}
        visible={this.props.opened}
        closeIcon={<CloseIcon/>}
        onCancel={this.onCancel}
        footer={<React.Fragment>
          <span><TranslatedText transKey="modals.common.dontHaveAccount"/></span>
          <a onClick={() => this.props.openModal({id: SignUpModalId})}>
            <TranslatedText transKey="modals.common.signUpLink"/>
            <ArrowLeft className="action-icon"/>
          </a>
        </React.Fragment>
        }
      >
        <div>
          {
            message &&
            <div className={`login-notification login-notification-${message.type}`}>
              {message.type === 'error' && <WarningTriangle/>}
              {message.type === 'success' && <SuccessCircle/>}
              <span>{message.text}</span>
            </div>
          }
          <FormError errors={this.props.errors} fieldName="non_field_errors"/>
          <form onSubmit={this.submit}>
            <div className="modal-form-group">
              <FormError.Tooltip errors={this.props.errors} fieldName="email">
                <Input placeholder={this.props.t('modals.login.emailPlaceholder')} id="email" name="email" value={this.state.email} onChange={e => this.setState({email: e.target.value})} required/>
              </FormError.Tooltip>
            </div>
            <div className="modal-form-group">
              <FormError.Tooltip errors={this.props.errors} fieldName="password">
                <Input placeholder={this.props.t('modals.login.passwordPlaceholder')} id="password" name="password" type="password" value={this.state.password} onChange={e => this.setState({password: e.target.value})} required/>
              </FormError.Tooltip>
            </div>
            <Button type="primary" block htmlType="submit" loading={this.state.inProgress}>
              <TranslatedText transKey="modals.login.submit"/>
            </Button>
          </form>
          <div className="submit-subelement">
            <a onClick={() => this.props.openModal({id: FORGOT_PASSWORD_MODAL_ID})}>
              <TranslatedText transKey="modals.login.forgotPasswordLink"/>
            <ArrowLeft className="action-icon"/>
            </a>
          </div>
        </div>
      </Modal>
    );
  }
}

LoginModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  data: PropTypes.object,
  errors: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  opened: isModalOpened(state)(LoginModalId),
  data: modalData(state),
  errors: authErrors(state),
});

const mapDispatchToProps = {
  openModal: makeAction(OPEN_MODAL),
  closeModal: makeAction(CLOSE_MODAL),
  login: makeAction(LOG_IN),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(LoginModal));



// WEBPACK FOOTER //
// /src/components/modals/LoginModal.jsx